<template>
    <div >
      <div class = "isb_box1">
        <div class = "isb_box2">
          <div class="row" style="margin-top: 10px;margin-bottom: 5px; padding: 0px 5px; width:100%">
          <label class = "isb_tabel1">{{t1}}</label>
            <div class = "isb_tabel2">
              <input type="text" class="textbox counter_text line1" :value="b1" readonly/>
              <label  class = "line2">件</label>
            </div>          
          </div>
          <div class="row" style="margin-bottom: 5px; padding: 0px 5px; width:100%">
          <label class = "isb_tabel1">{{t2}}</label>
            <div class = "isb_tabel2">
              <input type="text" class="textbox counter_text line1" :value="b2" readonly/>
              <label  class = "line2">件</label>
            </div>          
          </div> 
          <div class="row" style="margin-bottom: 5px; padding: 0px 5px; width:100%">
          <label class = "isb_tabel1">{{t3}}</label>
            <div class = "isb_tabel2">
              <input type="text" class="textbox counter_text line1" :value="b3" readonly/>
              <label  class = "line2">件</label>
            </div>          
          </div>
          <div class="row" style="margin-bottom: 5px; padding: 0px 5px; width:100%">
          <label class = "isb_tabel1">{{t4}}</label>
            <div class = "isb_tabel2">
              <input type="text" class="textbox counter_text line1" :value="b4" readonly/>
              <label  class = "line2">{{u4}}</label>
            </div>          
          </div> 
        </div>
      </div>
      <div
            style="color:red;margin-top: -15px;font-weight: bold;"
           v-if="counter_b3_error_message!='false'"
           v-html="counter_b3_error_message"></div>
    </div>
</template>
<script>
export default {
  mixins: [],
  computed: {
    b3Style(){
      var ret =  ( typeof  this.$props.counter_b3_error_message == "undefined" || this.$props.counter_b3_error_message == null || this.$props.counter_b3_error_message == "false")?"":"color:red;"
      return ret;
    }
  },
  methods: {},
  mounted() {},
  beforeDestroy() {},
  beforeMount() {},
  props: {
    t1: { type: String, default: "" },
    t2: { type: String, default: "" },
    t3: { type: String, default: "" },
    t4: { type: String, default: "" },
    u4: { type: String, default: "" },
    b1: { type: String, default: "-" },
    b2: { type: String, default: "-" },
    b3: { type: String, default: "-" },
    b4: { type: String, default: "-" },
    counter_b3_error_message: {type: String, default: "false" }
  },
};
</script>
<style scoped>
input:focus::-webkit-input-placeholder {
  color: transparent;
}
.counter_text {
text-align: right;
border-radius: 3px;
border: solid 1px gray;
padding-right:7px;
}
.isb_row1{
  width: 100%;
}
.isb_tabel1{
  float:left;
  margin-top : 5px ;
  height : 20%;
  margin-left: 5px;
  /* height: 20px; */
  width: 37%;
  /* font-size: 12px; */
  font-weight: normal;
}
.isb_tabel2{
  float:right; 
  width: 60%;
  height: 20px;
}

.line1{

  height: 20px;
  width: 80%;
}
.line2{
  width: 10%;
  font-weight: normal;
}
.isb_box1{
 
    /* height: 152px;  */
    height: 100%;
    width: 100%;
    background-color: #bdd6ec; 
    margin-right: auto;
    margin-left: auto;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.isb_box2{
    width: 90%;
    height: 90%;
    /* height: 130px; */
    margin-right: auto; 
    margin-left: auto;
    display: flex;
    flex-wrap: wrap; 
    align-items: center;
}
</style>



// WEBPACK FOOTER //
// inventory_summary_box.vue?78c285a0